import { Component, OnInit, ViewChild } from '@angular/core';
import { ContactDetailsService } from './contact-details.service';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { DetailsBox } from './contacts-details.model';
import { ConfirmComponent } from '../shared/confirm/confirm.component';
import { MatDialog } from '@angular/material/dialog';
import { DeleteDataAction } from '../contacts/contacts.actions';
import { Store } from '@ngrx/store';
import { IState } from '../shared/models/state';
import { MatMenuTrigger } from '@angular/material/menu';
import * as moment from 'moment';
import { saveAs } from 'file-saver';

@Component({
  selector: 'cc-event-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss']
})
export class ContactDetailsComponent implements OnInit {
  public recordId: number;
  public generalData: DetailsBox;
  public eventId: number;
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  constructor(
    public location: Location,
    private store: Store<IState>,
    public contactDetailsService: ContactDetailsService,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.recordId = +this.activatedRoute.snapshot.paramMap.get('recordId');
    this.eventId = +this.activatedRoute.snapshot.paramMap.get('eventId');

    this.contactDetailsService.getGeneralData(this.recordId).subscribe((data: DetailsBox) => {
      this.generalData = data;
    });
  }

  someMethod() {
    this.trigger.openMenu();
  }

  back() {
    this.location.back();
  }

  confirmToDelete() {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: 'auto',
      height: 'auto',
      data: {
        title: 'CONTACTS_LIST.ON_DELETE_ONE_TITLE',
        description: 'CONTACTS_LIST.ON_DELETE_DESCRIPTION',
        type: 'strong'
      },
      panelClass: 'confirm-dialog-wrapper'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'strong') {
        this.deleteSelected();
      }
    });
  }

  deleteSelected() {
    this.store.dispatch(new DeleteDataAction({ include: [this.recordId] }));
    this.back();
  }

  getPdf() {
    this.contactDetailsService
      .getContactDetailsReport({
        id: this.recordId,
        timezoneOffsetMinutes: moment().utcOffset()
      })
      .subscribe(result => {
        const blob = new Blob([result], { type: 'text/pdf' });
        saveAs(blob, 'CH_' + this.recordId + '_datasheet' + '.pdf');
      });
  }
}
